<template>
  <div class="home">
    <!-- <div class="home-head">
      <div class="home-head-text">
        {{ venueInfo.name }} {{ time }} {{ week }}
      </div>
      <el-button v-if="!wsToken" class="home-login-but" @click="loginQr"
        >登录</el-button
      >
    </div> -->
    <img src="../assets/bg.png" class="home-bg" />
    <div class="home-box">
      <div class="atm">
        <div class="atm-head">
          <div class="atm-venue">{{ venueInfo.name || '本场大屏' }}</div>
          <div class="atm-head-right">
            <el-button v-if="!wsToken" class="home-login-but" @click="loginQr">管理员登录</el-button>
          </div>
        </div>

        <div class="atm-main">
          <div class="atm-col atm-col-live">
            <div class="atm-panel">
              <div class="atm-panel-title">
                <span>匹配中</span>
                <span class="atm-panel-sub" v-if="!matchBoard.is_match_enabled">未开启</span>
                <span class="atm-panel-sub" v-else-if="!matchBoard.items.length">等你发信号</span>
              </div>
              <div class="atm-match-grid" v-if="matchBoard.items.length">
                <div
                  v-for="item in matchBoard.items"
                  :key="item.play_type"
                  class="atm-match-chip"
                >
                  <div class="atm-match-play">{{ item.play_type }}</div>
                  <div class="atm-match-hint">{{ item.hint }}</div>
                  <div class="atm-match-count">{{ item.count || 0 }}人</div>
                </div>
              </div>
              <div class="atm-empty" v-else>暂无求组 · 扫码进场发信号</div>
            </div>

            <div class="atm-panel atm-panel-grow">
              <div class="atm-panel-title">组局中</div>
              <div class="atm-gather-list" v-if="displayGathers.length">
                <div
                  v-for="(item, index) in displayGathers"
                  :key="item.id || index"
                  class="atm-gather-card"
                >
                  <img
                    v-if="gatherCover(item)"
                    :src="gatherCover(item)"
                    class="atm-gather-bg"
                    alt=""
                  />
                  <div class="atm-gather-mask"></div>
                  <div class="atm-gather-body">
                    <div class="atm-gather-name">{{ item.name || '组局' }}</div>
                    <div class="atm-gather-meta">
                      <span>{{ item.user_count || 0 }}/{{ item.max_user_count || '-' }}</span>
                      <span class="atm-gather-status">{{ gatherStatusText(item) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="atm-empty" v-else>暂无进行中的组局</div>
            </div>
          </div>

          <div class="atm-col atm-col-chat">
            <div class="atm-panel atm-panel-grow atm-panel-chat">
              <div class="atm-chat-head">
                <div class="atm-chat-head-main">
                  <span class="atm-chat-live-dot" aria-hidden="true"></span>
                  <span class="atm-chat-title">本场聊天</span>
                  <span class="atm-chat-count" v-if="displayChats.length"
                    >{{ displayChats.length }} 条</span
                  >
                </div>
                <span class="atm-chat-head-hint">扫码进场 · 实时滚动</span>
              </div>
              <div class="atm-chat-stage">
                <div class="atm-chat-list" ref="chatListEl">
                  <div
                    v-for="(item, index) in displayChats"
                    :key="item.id || ('c-' + index)"
                    class="atm-chat-row"
                    :class="{
                      'atm-chat-row-latest': index === displayChats.length - 1
                    }"
                    :style="{ '--accent': chatAccent(item, index) }"
                  >
                    <div class="atm-chat-avatar-wrap">
                      <img
                        :src="item.avatar_url || defaultAvatar"
                        class="atm-chat-avatar"
                        alt=""
                      />
                    </div>
                    <div class="atm-chat-body">
                      <div class="atm-chat-meta">
                        <span class="atm-chat-name">{{
                          item.nickname || '用户'
                        }}</span>
                        <span
                          class="atm-chat-time"
                          v-if="formatChatTime(item)"
                          >{{ formatChatTime(item) }}</span
                        >
                      </div>
                      <div
                        class="atm-chat-bubble"
                        :class="{
                          'atm-chat-bubble-image': isChatImage(item)
                        }"
                      >
                        <span
                          v-if="isChatImage(item)"
                          class="atm-chat-image-tag"
                          >图片</span
                        >
                        <span class="atm-chat-text">{{
                          isChatImage(item) ? '发了一张图片' : item.text
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="atm-chat-empty" v-if="!displayChats.length">
                    <div class="atm-chat-empty-title">场内还很安静</div>
                    <div class="atm-chat-empty-desc">
                      扫右下角入场码进小程序，在本场聊起来
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="atm-col atm-col-rank">
            <div class="atm-panel atm-panel-rank">
              <img src="../assets/rankBg.png" class="home-box-rank-bg" />
              <div class="home-box-rank-list">
                <div class="home-box-rank-tab">
                  <div class="rank-tab-item rank-tab-item-select">活跃榜</div>
                </div>

                <div class="home-box-rank-top">
                  <div class="rank-second flex-center">
                    <img src="../assets/rank2.png" class="rank-num-icon" />
                    <img :src="rank2.avatar_url || defaultAvatar" class="rank-top-image" />
                    <div class="rank-top-name">
                      {{ rank2.nickname || '暂无用户' }}
                    </div>
                    <div class="rank-top-coin">{{ rank2.score || 0 }}</div>
                  </div>
                  <div class="rank-first flex-center flex-center-first">
                    <img src="../assets/rank1.png" class="rank-num-icon" />
                    <img
                      :src="rank1.avatar_url || defaultAvatar"
                      class="rank-top-image rank-top-image-first"
                    />
                    <div class="rank-top-name rank-first-name">
                      {{ rank1.nickname || '暂无用户' }}
                    </div>
                    <div class="rank-top-coin">{{ rank1.score || 0 }}</div>
                  </div>
                  <div class="rank-third flex-center">
                    <img src="../assets/rank3.png" class="rank-num-icon" />
                    <img
                      :src="rank3.avatar_url || defaultAvatar"
                      class="rank-top-image rank-top-image-third"
                    />
                    <div class="rank-top-name">
                      {{ rank3.nickname || '暂无用户' }}
                    </div>
                    <div class="rank-top-coin">{{ rank3.score || 0 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="home-danmu"> -->
      <vue-danmaku
        ref="danmakuTeam"
        v-model="danmuTeams"
        use-slot
        :randomChannel="true"
        :speeds="150"
        class="home-team-danmu"
      >
        <template slot="dm" slot-scope="{ danmu }">
          <!-- <div class="home-danmu-item">
            <img :src="danmu.avatar_url" class="home-danmu-img" />
            <div class="home-danmu-name">{{ danmu.nickname }}:</div>
            <div class="home-danmu-text">{{ danmu.text }}</div>
          </div> -->
          <div class="barrage-box">
            <img
              :src="danmu.fish.headImg"
              class="barrage-head-img"
              :style="{ width: danmu.fish.headW, height: danmu.fish.headH }"
            />
            <div
              class="barrage-info-box"
              :class="[
                danmu.fishType === 'minnow' ? 'barrage-info-box-minnow ' : ''
              ]"
            >
              <div
                class="barrage-info-up"
                :style="{
                  background: danmu.fish.upBg,
                  color: danmu.fish.upColor,
                  height: danmu.fish.upBoxH,
                  lineHeight: danmu.fish.upBoxH
                }"
              >
                {{ danmu.name }}
              </div>
              <div
                class="barrage-info-down"
                :style="{
                  background: danmu.fish.downBg,
                  color: danmu.fish.downColor,
                  height: danmu.fish.downBoxH,
                  lineHeight: danmu.fish.downBoxH
                }"
              >
                {{ danmu.dayFormat }} 人数: {{ danmu.user_count || 0 }}/{{
                  danmu.max_user_count
                }}
              </div>

              <div
                class="barrage-box-up-img-box"
                :style="{ top: `-${danmu.fish.upH}`, height: danmu.fish.upH }"
              >
                <img
                  :src="danmu.fish.upImg"
                  :style="{ width: danmu.fish.upW, height: danmu.fish.upH }"
                />
              </div>
              <div
                class="barrage-box-down-img-box"
                :style="{
                  bottom: `-${danmu.fish.downH}`,
                  height: danmu.fish.downH
                }"
              >
                <img
                  :src="danmu.fish.downImg"
                  :style="{ width: danmu.fish.downW, height: danmu.fish.downH }"
                />
              </div>
            </div>
            <img
              v-if="danmu.fish.tailImg"
              :src="danmu.fish.tailImg"
              class="barrage-tail-img"
              :style="{ width: danmu.fish.tailW, height: danmu.fish.tailH }"
            />
          </div>
        </template>
      </vue-danmaku>

      <vue-danmaku
        ref="danmaku"
        v-model="danmus"
        use-slot
        :randomChannel="true"
        :speeds="200"
        class="home-danmu"
      >
        <!-- 弹幕插槽（vue 2.6.0 及以上版本可使用 v-slot:dm="{ index, danmu }"语法） -->
        <template slot="dm" slot-scope="{ danmu }">
          <div v-if="danmu.type === 'chat'" class="home-danmu-item">
            <img :src="danmu.avatar_url" class="home-danmu-img" />
            <div class="home-danmu-name">{{ danmu.nickname }}:</div>
            <div class="home-danmu-text">{{ danmu.text }}</div>
          </div>
          <div v-if="danmu.type === 'gift'" class="home-danmu-item">
            <img :src="danmu.avatar_url" class="home-danmu-img" />
            <!-- <div class="home-danmu-name">{{ danmu.nickname }}:</div> -->
            <div class="home-danmu-text">{{ danmu.text }}</div>
          </div>
        </template>
        <!-- 容器插槽 -->
        <div></div>
      </vue-danmaku>
      <!-- </div> -->

      <div class="home-foot">
        <el-button v-if="!wsToken" class="home-login-but" @click="loginQr"
          >登录</el-button
        >
        <div
          class="home-foot-catalog"
          v-if="displayPlayTypes.length || displayServices.length"
        >
          <template v-if="displayPlayTypes.length">
            <span class="home-foot-catalog-label">组局</span>
            <span
              v-for="item in displayPlayTypes"
              :key="'play-' + item.name"
              class="home-foot-catalog-chip home-foot-catalog-chip-play"
            >{{ item.name }}</span>
          </template>
          <template v-if="displayServices.length">
            <span class="home-foot-catalog-sep" v-if="displayPlayTypes.length">|</span>
            <span class="home-foot-catalog-label">工具</span>
            <span
              v-for="item in displayServices"
              :key="'svc-' + (item.id || item.name)"
              class="home-foot-catalog-chip home-foot-catalog-chip-tool"
            >{{ item.name }}</span>
          </template>
        </div>
      </div>

      <div class="home-foot-time">
        <div class="home-foot-time-box">
          <div class="home-foot-date">
            <div class="home-foot-year">{{ year }}</div>
            <div class="home-foot-md">{{ md }}</div>
          </div>
          <div class="home-foot-time-info">
            <div class="home-foot-week">{{ week }}</div>
            <div class="home-foot-time-ms">{{ time }}</div>
          </div>
        </div>
      </div>

      <div class="home-venue-qr">
        <img
          v-if="entranceImageUrl"
          :src="entranceImageUrl"
          class="home-venue-qr-img"
          alt="入场码"
        />
        <vue-qr
          v-else
          ref="qrCode"
          :text="textValue"
          class="home-venue-qr-img"
        ></vue-qr>

        <div class="home-venue-qr-text">扫码组局</div>
      </div>
    </div>

    <el-dialog
      title="登录"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <div class="login-box">
        <div class="login-title">扫码登录</div>
        <div class="login-qr">
          <vue-qr ref="qrCode" :text="loginValue" class="login-qr-img"></vue-qr>
        </div>
        <div class="login-text">管理员打开微信扫一扫登录</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import autofit from 'autofit.js'
import vueDanmaku from 'vue-danmaku'
// import vueSeamlessScroll from 'vue-seamless-scroll'
import { mapActions, mapGetters } from 'vuex'
// import VueDragResize from 'vue-drag-resize'
import VueQr from 'vue-qr'
import {
  gatherList,
  createScanCode,
  scanCodeInfo,
  getVenueInfo,
  boardSignals,
  entranceCodeInfo
} from '@/api/team/index.js'
import { fish } from '@/utils/fish.js'
import { deepClone } from '@/utils/index.js'

export default {
  name: 'Home',
  components: { vueDanmaku, VueQr },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      page_size: 10,
      total_page: 1,
      rankList: [],
      teamList: [],
      danmus: [],
      danmuTeams: [],
      classOption: {
        // singleHeight: 120,
        hoverStop: false,
        step: 0.9
      },
      width: 302,
      height: 361,
      top: 300,
      left: 0,
      textValue: `${process.env['VUE_APP_API']}/venueHome?id=1`,
      venueId: 2,
      dialogVisible: false,
      loginValue: '',
      timer: null,
      teamTimer: null,
      teamData: [],
      venueInfo: {},
      secret_token: '',
      sign: '',
      damuBackList: [
        'rgba(255, 160, 37, 0.5)',
        'rgba(149, 162, 255, 0.5)',
        'rgba(173, 214, 60, 0.5)',
        'rgba(252, 179, 178, 0.5)'
      ],
      chatAccentList: [
        '#0099ee',
        '#ff6b00',
        '#07c160',
        '#7b61ff',
        '#e91e8c',
        '#00b8a9'
      ],
      time: '',
      year: '',
      md: '',
      week: '',
      weekList: ['日', '一', '二', '三', '四', '五', '六'],
      rank1: {},
      rank2: {},
      rank3: {},
      fishList: fish,
      defaultAvatar: 'https://static.superyuwang.com/default/avatar.png',
      chatList: [],
      isFirst: true,
      matchBoard: {
        is_match_enabled: 0,
        total: 0,
        items: [],
        line: '',
        present_count: 0,
        gather_recruiting: 0,
        gather_ongoing: 0,
        gathers: [],
        chats: [],
        active_rank: [],
        play_types: [],
        services: []
      },
      entranceImageUrl: ''
    }
  },
  computed: {
    displayGathers() {
      const fromBoard = (this.matchBoard && this.matchBoard.gathers) || []
      if (fromBoard.length) return fromBoard.slice(0, 8)
      return (this.teamList || []).slice(0, 8)
    },
    displayChats() {
      const list = this.chatList || []
      if (list.length) return list.slice(-40)
      return ((this.matchBoard && this.matchBoard.chats) || []).slice(-40)
    },
    displayPlayTypes() {
      const list = (this.matchBoard && this.matchBoard.play_types) || []
      return list.filter((x) => x && x.name).slice(0, 24)
    },
    displayServices() {
      const list = (this.matchBoard && this.matchBoard.services) || []
      return list.filter((x) => x && x.name).slice(0, 24)
    },
    ...mapGetters(['wsToken', 'isSocket', 'msg'])
  },
  watch: {
    wsToken(val) {
      console.log(val)
    },
    isSocket(val) {
      console.log('socket连接', val)
      if (val) {
        this.joinVenue()
        this.sendRank()
      }
    },
    msg(val) {
      try {
        const msg = JSON.parse(val)
        if (msg.code === 401) {
          this['ws/logout']()
          this.$message.error(msg.message)
        }
        if (msg.action === 'VenueChatSendSuccessEvent') {
          this.updateChat(msg)
        }
        if (msg.action === 'UserSendGiftToOtherEvent') {
          this.updateGift(msg)
        }
        if (msg.action === 'ClientRankActiveUser') {
          this.applyActiveRank(msg.data)
        }
        if (msg.action === 'ClientMessageList' || msg.action === 'ClientMessageListEvent') {
          this.applyChatHistory(msg.data)
        }
      } catch {
        console.log(val)
      }
    }
  },
  created() {
    autofit.init({
      dh: 1080,
      dw: 1920,
      el: 'body',
      resize: true
    })
  },
  mounted() {
    this.$refs.danmaku.play()
    this.venueId = this.$route.query.venueId || this.$route.query.id || 1
    this.getInfo()
    setInterval(() => {
      this.getTime()
    }, 1000)
    this.getTeamList()
    this.getMatchBoard()

    if (this.wsToken) {
      this['ws/WEBSOCKET_INIT']()
    }
  },
  beforeDestroy() {
    this['ws/quitApp']()
  },
  methods: {
    ...mapActions([
      'ws/WEBSOCKET_INIT',
      'ws/setToken',
      'ws/logout',
      'ws/WEBSOCKET_SEND',
      'ws/quitApp'
    ]),
    getRandom(max = 10, min = 0) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    chatAccent(item, index = 0) {
      const colors = this.chatAccentList || []
      if (!colors.length) return '#0099ee'
      const uid = Number((item && (item.user_id || item.uid)) || 0)
      if (uid > 0) return colors[uid % colors.length]
      const name = String((item && item.nickname) || '')
      let hash = 0
      for (let i = 0; i < name.length; i++) {
        hash = (hash + name.charCodeAt(i) * (i + 1)) % 997
      }
      return colors[(hash + index) % colors.length]
    },
    formatChatTime(item) {
      if (!item) return ''
      const raw =
        item.created_at ||
        item.createdAt ||
        item.time ||
        item.send_at ||
        ''
      if (!raw) return ''
      const d = this.$day(raw)
      if (!d.isValid()) return ''
      const today = this.$day().format('YYYY-MM-DD')
      if (d.format('YYYY-MM-DD') === today) return d.format('HH:mm')
      return d.format('MM-DD HH:mm')
    },
    isChatImage(item) {
      const t = String((item && item.text) || '')
      return t === '[图片]' || t === '图片' || item.type === 'image'
    },

    updateChat(data) {
      const payload = (data && data.data) || {}
      const obj = {
        id: payload.venue_chat_id || payload.id,
        user_id: payload.user_id || payload.uid || 0,
        avatar_url: payload.avatar_url,
        nickname: payload.nickname,
        type: 'chat',
        created_at: payload.created_at || this.$day().format('YYYY-MM-DD HH:mm:ss'),
        background: this.damuBackList[this.getRandom(this.damuBackList.length)],
        ...payload
      }

      try {
        const msg = JSON.parse(data.message)
        if (msg.type) {
          if (msg.type === 'text') obj.text = msg.msg
          if (msg.type === 'image') {
            obj.text = '[图片]'
            obj.type = 'image'
          }
        } else {
          obj.text = data.message
        }
      } catch {
        obj.text = data.message
      }
      if (!obj.text) return
      this.chatList = [...(this.chatList || []), obj].slice(-60)
      this.$nextTick(() => this.scrollChatToBottom())
      if (this.$refs.danmaku) {
        this.$refs.danmaku.insert(obj)
      }
    },
    updateGift(data) {
      const obj = {
        avatar_url: data.user.avatar_url,
        nickname: data.user.nickname,
        type: 'gift',
        background: this.damuBackList[this.getRandom(this.damuBackList.length)],
        // ...data.data,
        text: data.data
      }

      // try {
      //   const msg = JSON.parse(data.message)
      //   if (msg.type) {
      //     if (msg.type === 'text') obj.text = msg.msg
      //     // if(msg.type === 'image') obj.image_url = msg.image_url
      //   } else {
      //     obj.text = data.message
      //   }
      // } catch {
      //   obj.text = data.message
      // }
      this.$refs.danmaku.insert(obj)
    },
    resize(newRect) {
      this.width = newRect.width
      this.height = newRect.height
      this.top = newRect.top
      this.left = newRect.left
    },
    getTimestamp() {
      return new Date().getTime()
    },
    async getTeamList() {
      const { data } = await gatherList({
        venue_id: this.venueId,
        page: 1,
        page_size: 99
      })

      let minnowIndex = 0
      let mediumIndex = 0
      let bigIndex = 0
      data.list = data.list
        .map((item) => {
          const day = this.$day(item.day_at).format('MM.DD')
          const week = `周${this.weekList[this.$day(item.day_at).day()]}`
          item.dayFormat = `${day} ${week} ${item.start_hour}:${
            item.start_minute || '00'
          }`

          const endDate = `${this.$day(item.day_at).format('YYYY/MM/DD')} ${
            item.end_hour
          }:${item.end_minute || '00'}`
          item.timestamp = new Date(endDate).getTime()

          if (item.max_user_count <= 4) {
            // 小鱼
            const fistList = this.fishList.minnow
            const i = minnowIndex % fistList.length
            item.fish = fistList[i]
            minnowIndex = minnowIndex + 1
            item.fishType = 'minnow'
          } else if (item.max_user_count > 4 && item.max_user_count < 9) {
            // 中鱼
            const fistList = this.fishList.medium
            const i = mediumIndex % fistList.length
            item.fish = fistList[i]
            mediumIndex = mediumIndex + 1
            item.fishType = 'medium'
          } else {
            // 大鱼
            const fistList = this.fishList.big
            const i = bigIndex % fistList.length
            item.fish = fistList[i]
            bigIndex = bigIndex + 1
            item.fishType = 'big'
          }

          return item
        })
        .filter((item) => {
          if (Number(item.status) === 3) return true
          return item.timestamp > this.getTimestamp()
        })
      this.teamList = data.list
      // this.danmuTeams = data.list
      // if (data.list.length > this.teamList.length) {
      //   this.teamList = data.list
      // }
      // if (
      //   data.list.length === this.teamList.length &&
      //   this.teamList.length > 0
      // ) {
      //   if (data.list[0].id !== this.teamList[0].id) {
      //     this.teamList = data.list
      //     this.$refs.teamScroll.reset()
      //   }
      // }
      this.timeSend()
      setTimeout(() => {
        this.getTeamList()
      }, 30000)
    },
    timeSend() {
      if (!this.teamList.length) return
      this.teamData = deepClone(this.teamList)
      clearInterval(this.teamTimer)
      this.teamTimer = setInterval(() => {
        // clearInterval(this.timer)
        if (this.isStop) {
          clearInterval(this.teamTimer)
          return
        }
        var talk = this.teamData.pop()
        if (talk) {
          // this.barrage.send(talk)
          if (talk.timestamp && talk.timestamp > this.getTimestamp()) {
            this.$refs.danmakuTeam.insert(talk)
          }
        } else {
          clearInterval(this.teamTimer)
          this.timeSend()
        }
      }, 1500)
    },
    async loginQr() {
      const { data } = await createScanCode({
        venue_id: this.venueId,
        code_type: 1
      })
      const info = data.data.data
      this.sign = info.sign
      this.secret_token = info.token
      this.loginValue = `${process.env['VUE_APP_API']}/autofit?code=${info.token}&sign=${info.sign}`
      this.dialogVisible = true
      this.checkState()
      // this.teamList = data.list
      console.log(data.data.data)
    },
    async checkState() {
      clearTimeout(this.timer)
      try {
        const { data } = await scanCodeInfo({
          code: this.secret_token,
          code_type: 1,
          sign: this.sign
        })
        if (data.status === 3) {
          this.dialogVisible = false
          this.$message({ message: '登录成功', type: 'success' })
          this['ws/setToken'](data.data.login_token)
          // this.getTicketList()
        } else if (data.status === 0) {
          // Toast('二维码失效,请重新出示')
          this.$message('二维码失效,请重试')
        } else {
          this.timeCheck()
        }
        console.log(data)
      } catch (err) {
        console.log(err)
        this.timeCheck()
      }
    },
    timeCheck() {
      if (!this.dialogVisible) {
        clearTimeout(this.timer)
        return
      }
      this.timer = setTimeout(() => {
        this.checkState()
      }, 3000)
    },
    async getInfo() {
      const { data } = await getVenueInfo({ venue_id: this.venueId })
      console.log(data)
      if (data.name) {
        this.venueInfo = data
        const apiHost = String(process.env['VUE_APP_API'] || 'https://apizone.superyuwang.com').replace(
          /^http:\/\//i,
          'https://'
        )
        this.textValue = `${apiHost.replace(/\/$/, '')}/venueHome?id=${data.id}&scene=1`
        this.loadEntranceCode()
      } else {
        this.venueId = 1
        this.getInfo()
      }
    },
    async loadEntranceCode() {
      try {
        const { data } = await entranceCodeInfo({ venue_id: this.venueId })
        this.entranceImageUrl = (data && data.image_url) || ''
        if (data && data.h5_fallback_url) {
          this.textValue = data.h5_fallback_url
        }
      } catch (e) {
        this.entranceImageUrl = ''
      }
    },
    joinVenue() {
      const data = {
        action: `ClientJoin_${this.venueId}`,
        data: [],
        push: { venue_id: this.venueId }
      }
      console.log(JSON.stringify(data))
      this['ws/WEBSOCKET_SEND'](JSON.stringify(data))
      this.requestChatHistory()
    },
    requestChatHistory() {
      const data = {
        action: 'ClientMessageList',
        data: { start_id: '', end_id: '' },
        push: { venue_id: this.venueId }
      }
      this['ws/WEBSOCKET_SEND'](JSON.stringify(data))
    },
    sendRank() {
      const data = {
        action: 'ClientRankActiveUser',
        data: [],
        push: { venue_id: this.venueId }
      }
      this['ws/WEBSOCKET_SEND'](JSON.stringify(data))
      setTimeout(() => {
        this.sendRank()
      }, 10000)
    },
    applyActiveRank(list) {
      const rows = Array.isArray(list) ? list.slice() : []
      // 按 rank 升序，其次 score 降序，避免接口乱序导致领奖台错位
      rows.sort((a, b) => {
        const ra = Number((a && a.rank) || 0)
        const rb = Number((b && b.rank) || 0)
        if (ra && rb && ra !== rb) return ra - rb
        return Number((b && b.score) || 0) - Number((a && a.score) || 0)
      })
      this.rank1 = rows[0] || {}
      this.rank2 = rows[1] || {}
      this.rank3 = rows[2] || {}
    },
    applyChatHistory(list) {
      if (!Array.isArray(list) || !list.length) return
      const mapped = list
        .map((row) => {
          let text = ''
          try {
            const msg = typeof row.message === 'string' ? JSON.parse(row.message) : row.message
            if (msg && msg.type === 'text') text = msg.msg
            else if (msg && msg.type === 'image') text = '[图片]'
            else text = row.message || row.text || ''
          } catch {
            text = row.message || row.text || ''
          }
          return {
            id: row.id || row.venue_chat_id,
            user_id: row.user_id || row.uid || 0,
            nickname: row.nickname,
            avatar_url: row.avatar_url,
            text,
            type: text === '[图片]' ? 'image' : 'chat',
            created_at: row.created_at || row.createdAt || row.time || ''
          }
        })
        .filter((x) => x.text)
        .reverse()
      if (!mapped.length) return
      this.chatList = mapped.slice(-60)
      this.$nextTick(() => this.scrollChatToBottom())
    },
    scrollChatToBottom() {
      const el = this.$refs.chatListEl
      if (el) el.scrollTop = el.scrollHeight
    },
    getTime() {
      this.time = this.$day().format('HH:mm:ss')
      this.year = this.$day().format('YYYY')
      this.md = this.$day().format('MM.DD')
      this.week = `周${this.weekList[this.$day().day()]}`
    },
    async getMatchBoard() {
      try {
        const { data } = await boardSignals({ venue_id: this.venueId })
        this.matchBoard = {
          is_match_enabled: (data && data.is_match_enabled) || 0,
          total: (data && data.total) || 0,
          items: (data && data.items) || [],
          line: (data && data.line) || '',
          present_count: (data && data.present_count) || 0,
          gather_recruiting: (data && data.gather_recruiting) || 0,
          gather_ongoing: (data && data.gather_ongoing) || 0,
          gathers: (data && data.gathers) || [],
          chats: (data && data.chats) || [],
          active_rank: (data && data.active_rank) || [],
          play_types: (data && data.play_types) || [],
          services: (data && data.services) || []
        }
        if (!this.wsToken) {
          this.chatList = (this.matchBoard.chats || []).slice()
          this.$nextTick(() => this.scrollChatToBottom())
        } else if (!this.chatList.length && this.matchBoard.chats && this.matchBoard.chats.length) {
          this.chatList = this.matchBoard.chats.slice()
          this.$nextTick(() => this.scrollChatToBottom())
        }
        // WS 已连时由 ClientRankActiveUser 刷新活跃榜；此处仅作未登录/断线兜底，避免两套口径互相覆盖闪回
        if (!this.isSocket) {
          this.applyActiveRank(this.matchBoard.active_rank)
        }
      } catch (e) {
        console.log('match board fail', e)
      }
      setTimeout(() => {
        this.getMatchBoard()
      }, 15000)
    },
    gatherCover(item) {
      if (!item) return ''
      if (item.image_url) return item.image_url
      if (item.gather_category && item.gather_category.image_url) {
        return item.gather_category.image_url
      }
      if (item.category && item.category.image_url) return item.category.image_url
      const list = item.image_list
      if (Array.isArray(list) && list[0] && list[0].image_url) return list[0].image_url
      if (list && list.image_url) return list.image_url
      return ''
    },
    gatherStatusText(item) {
      const s = Number(item && item.status)
      if (s === 3) return '进行中'
      if (s === 1) return '招募中'
      return item.statusName || '组局'
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.home-bg {
  position: absolute;
  bottom: 24px;
  // left: -21px;
  width: 100%;
  // height: 893px;
}

.home-head {
  height: 122px;
  background: #313fa1;
  display: flex;
  align-items: center;
  padding: 0 45px;
}
.home-head-text {
  font-size: 32px;
  font-weight: 500;
  line-height: 21px;
  color: #ffffff;
  flex: 1;
}
.home-box {
  flex: 1;
  position: relative;
  overflow: hidden;
}

.atm {
  position: relative;
  z-index: 5;
  height: 100%;
  padding: 28px 40px 160px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}
.atm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  pointer-events: auto;
}
.atm-venue {
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}
.atm-main {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 24px;
  pointer-events: auto;
}
.atm-col {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
}
.atm-col-live {
  flex: 1;
  min-width: 0;
}
.atm-col-chat {
  flex: 1.55;
  min-width: 0;
}
.atm-col-rank {
  width: 460px;
  flex-shrink: 0;
  overflow: hidden;
}
.atm-panel {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 28px;
  padding: 22px 24px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  min-height: 0;
}
.atm-panel-grow {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.atm-panel-chat {
  min-height: 0;
  padding: 0;
  overflow: hidden;
  background: linear-gradient(165deg, #f7fbff 0%, #ffffff 42%, #fff8f0 100%);
  border: 2px solid rgba(0, 153, 238, 0.18);
}
.atm-chat-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.72);
}
.atm-chat-head-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.atm-chat-live-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #07c160;
  box-shadow: 0 0 0 0 rgba(7, 193, 96, 0.55);
  animation: atm-chat-pulse 1.6s ease-out infinite;
  flex-shrink: 0;
}
@keyframes atm-chat-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(7, 193, 96, 0.55);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(7, 193, 96, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(7, 193, 96, 0);
  }
}
.atm-chat-title {
  font-size: 32px;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.1;
}
.atm-chat-count {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(0, 153, 238, 0.12);
  color: #0099ee;
  font-size: 20px;
  font-weight: 700;
}
.atm-chat-head-hint {
  flex-shrink: 0;
  font-size: 20px;
  font-weight: 600;
  color: #969799;
}
.atm-chat-stage {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.atm-chat-stage::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 28px;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(247, 251, 255, 0.95) 0%,
    rgba(247, 251, 255, 0) 100%
  );
}
.atm-chat-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 20px 22px;
  box-sizing: border-box;
}
.atm-chat-row {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  animation: atm-chat-in 0.35s ease-out;
}
.atm-chat-row-latest .atm-chat-bubble {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}
@keyframes atm-chat-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.atm-chat-avatar-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  flex-shrink: 0;
  padding: 3px;
  background: linear-gradient(135deg, var(--accent, #0099ee), #ffffff);
  box-sizing: border-box;
}
.atm-chat-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #eee;
  border: 2px solid #fff;
  box-sizing: border-box;
}
.atm-chat-body {
  min-width: 0;
  flex: 1;
}
.atm-chat-meta {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 6px;
  padding-left: 4px;
}
.atm-chat-name {
  font-size: 22px;
  font-weight: 800;
  color: var(--accent, #576b95);
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.atm-chat-time {
  font-size: 18px;
  font-weight: 600;
  color: #b0b3b8;
}
.atm-chat-bubble {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  padding: 14px 18px;
  border-radius: 4px 22px 22px 22px;
  background: #ffffff;
  border: 2px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 14px rgba(26, 26, 26, 0.05);
  box-sizing: border-box;
}
.atm-chat-bubble::before {
  content: '';
  position: absolute;
  left: -2px;
  top: 0;
  width: 5px;
  height: 100%;
  border-radius: 4px 0 0 22px;
  background: var(--accent, #0099ee);
}
.atm-chat-bubble-image {
  background: linear-gradient(135deg, #fff7e6 0%, #ffffff 70%);
  border-color: rgba(255, 160, 37, 0.35);
}
.atm-chat-image-tag {
  flex-shrink: 0;
  padding: 2px 10px;
  border-radius: 10px;
  background: #ffa025;
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 800;
}
.atm-chat-text {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  word-break: break-word;
}
.atm-chat-empty {
  margin: auto 0;
  padding: 48px 20px;
  text-align: center;
}
.atm-chat-empty-title {
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
}
.atm-chat-empty-desc {
  margin-top: 10px;
  font-size: 22px;
  font-weight: 600;
  color: #969799;
  line-height: 1.4;
}
.atm-panel-rank {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: 18px 16px 24px;
}
.atm-panel-title {
  display: flex;
  align-items: baseline;
  gap: 14px;
  font-size: 32px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 16px;
}
.atm-panel-sub {
  font-size: 22px;
  font-weight: 600;
  color: #969799;
}
.atm-match-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.atm-match-chip {
  min-width: 160px;
  padding: 16px 20px;
  border-radius: 20px;
  background: linear-gradient(135deg, #fff7e6 0%, #ffffff 70%);
  border: 3px solid #ffa025;
}
.atm-match-play {
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
}
.atm-match-hint {
  margin-top: 4px;
  font-size: 24px;
  font-weight: 700;
  color: #ff6b00;
}
.atm-match-count {
  margin-top: 2px;
  font-size: 20px;
  color: #969799;
}
.atm-gather-list {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  overflow: hidden;
  align-content: flex-start;
}
.atm-gather-card {
  position: relative;
  width: calc(50% - 7px);
  height: 110px;
  border-radius: 18px;
  overflow: hidden;
  background: #f2f3f5;
  border: 2px solid rgba(0, 153, 238, 0.35);
}
.atm-gather-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.atm-gather-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    160deg,
    rgba(255, 255, 255, 0.78) 0%,
    rgba(255, 255, 255, 0.9) 100%
  );
}
.atm-gather-body {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 14px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.atm-gather-name {
  font-size: 26px;
  font-weight: 800;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.atm-gather-meta {
  display: flex;
  justify-content: space-between;
  font-size: 22px;
  font-weight: 700;
  color: #ff6b00;
}
.atm-gather-status {
  color: #0099ee;
}
.atm-empty {
  padding: 28px 8px;
  text-align: center;
  font-size: 24px;
  color: #969799;
}

.home-box-info {
  padding: 0 83px;
  display: flex;
  height: 100%;
}
.home-box-right {
  width: 580px;
  height: 340px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
}
.home-box-rank-bg {
  margin-top: 12px;
  width: 120px;
  height: 79px;
  flex-shrink: 0;
}
.home-box-left {
  overflow: hidden;
  margin-left: 67px;
  flex: 1;
}
.home-box-rank {
  font-size: 72px;
  text-align: center;
  display: flex;
  // align-items: center;
  letter-spacing: 0px;
  color: #ffffff;
}
.home-box-rank-list {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 28px;
  background: #ffffff;
  padding: 18px 10px 22px;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
}
.home-box-rank-tab {
  display: flex;
  align-items: center;
  justify-content: center;
}
.rank-tab-item {
  padding: 0 24px;
  font-size: 28px;
  text-align: center;
  color: #1a1a1a;
  position: relative;
}

.rank-tab-item-select {
  color: #0099ee;
  font-weight: bold;
}
.home-box-rank-top {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 6px;
  box-sizing: border-box;
  overflow: hidden;
}
.rank-num-icon {
  width: 32px;
  height: 24px;
  margin-bottom: 4px;
}

.rank-second {
  flex: 1;
  min-width: 0;
  max-width: 130px;
  margin-top: 28px;
}

.rank-first {
  flex: 1.1;
  min-width: 0;
  max-width: 148px;
}

.rank-third {
  flex: 1;
  min-width: 0;
  max-width: 130px;
  margin-top: 28px;
}

.flex-center {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.rank-top-image {
  width: 72px;
  height: 72px;
  background: rgba(127, 127, 127, 0.3);
  border-radius: 50%;
  border: 3px solid #dbdbdb;
  object-fit: cover;
  flex-shrink: 0;
}

.rank-top-image-first {
  width: 96px;
  height: 96px;
  border: 3px solid #fde100;
}
.rank-top-image-third {
  border: 3px solid #ffbc7d;
}

.rank-top-name {
  margin-top: 10px;
  width: 100%;
  font-size: 18px;
  color: #1a1a1a;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rank-top-coin {
  margin-top: 4px;
  font-size: 22px;
  font-weight: bold;
  color: #1a1a1a;
}
.rank-first-name {
  margin-top: 8px;
}

.m-t-16 {
  margin-top: 16px;
}
.m-t-6 {
  margin-top: 6px;
}
.home-box-rank-item {
  display: flex;
  align-items: center;
  margin-bottom: 55px;
}
.home-box-rank-item-num {
  font-size: 64px;
  text-align: center;
  display: flex;
  align-items: center;
  width: 110px;
  height: 96px;
  color: #ffffff;
}
.home-box-rank-item-img {
  width: 110px;
  height: 110px;
  border-radius: 50%;
}
.home-box-rank-item-name {
  margin-left: 30px;
  font-size: 64px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-box-team-item {
  // width: 100%;
  padding: 20px 30px 20px 20px;
  border-radius: 60px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  width: max-content;
  // align-items: center;
  overflow: hidden;
  max-width: 1000px;
}
.home-box-team-item-img {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}
.home-box-team-item-info {
  margin-left: 10px;
  flex: 1;
  overflow: hidden;
  // flex-grow: 1;
}
.home-box-team-item-name {
  font-size: 32px;
  // font-weight: 500;
  color: #3d3d3d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-box-team-item-title {
  margin-top: 10px;
  font-size: 24px;
  // font-weight: 500;
  color: #aaaaaa;
}
.home-team-danmu {
  position: absolute;
  // bottom: 60px;
  top: 30px;
  height: 100%;
  width: 100%;
  pointer-events: none;
  // margin-top: 60px;
}
.home-danmu {
  position: absolute;
  bottom: 60px;
  height: 50%;
  width: 100%;
}
.home-danmu-item {
  display: flex;
  align-items: center;
  padding: 10px 24px 10px 10px;
  background: #ffd400;
  border-radius: 35px;
}
.home-danmu-img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
}
.home-danmu-name {
  margin-left: 10px;
  font-size: 21px;
  font-weight: 500;
  color: #1a1a1a;
}
.home-danmu-text {
  margin-left: 5px;
  font-size: 21px;
  font-weight: 500;
  color: #1a1a1a;
}
.home-venue-qr {
  position: absolute;
  bottom: 31px;
  // top: 338px;
  right: 26px;
  background: #fff;
  border-radius: 27px;
  border: 5px solid #000000;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 12;
  // cursor: move;
}
.home-venue-qr-img {
  width: 150px;
  height: 150px;
  background: #ffffff;
}
.home-venue-qr-text {
  // margin-top: 10px;
  font-weight: bold;
  font-size: 25px;
  color: #1a1a1a;
}
.home-venue-qr-name {
  margin-top: 16px;
  font-weight: 500;
  font-size: 40px;
  color: #ffa025;
}
.login-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.login-title {
  color: #252933;
  font-size: 1.33rem;
  font-weight: 500;
  margin-bottom: 20px;
}
.login-qr {
  border: 1.5px solid #e4e6eb;
  border-radius: 4px;
  width: 222px;
  height: 222px;
}
.login-qr-img {
  width: 222px;
  height: 222px;
}
.login-text {
  margin-top: 30px;
  color: #515767;
}
.home-login-but {
  // background: rgba(30, 128, 255, 0.05);
  // color: #fff;
  width: 96px;
  height: 48px;
  background: #ffffff;
  color: #1a1a1a;
  font-weight: bold;
  font-size: 28px;
}
.home-match-bar {
  position: absolute;
  left: 40px;
  bottom: 90px;
  z-index: 12;
  max-width: 1180px;
  display: flex;
  align-items: center;
  padding: 14px 22px;
  border-radius: 40px;
  background: rgba(0, 0, 0, 0.72);
  border: 3px solid #ffa025;
}
.home-match-label {
  flex-shrink: 0;
  margin-right: 18px;
  padding: 6px 16px;
  border-radius: 24px;
  background: #ffa025;
  color: #1a1a1a;
  font-size: 26px;
  font-weight: bold;
  line-height: 1.2;
}
.home-match-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 20px;
}
.home-match-chip {
  display: flex;
  align-items: baseline;
  color: #ffffff;
  font-weight: 600;
}
.home-match-play {
  font-size: 30px;
  line-height: 1.2;
}
.home-match-hint {
  margin-left: 8px;
  font-size: 26px;
  color: #ffa025;
  line-height: 1.2;
}
.home-foot {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 136px;
  background: #000000;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 0 420px 0 30px;
  box-sizing: border-box;
  gap: 16px;
}
.home-foot-catalog {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  overflow: hidden;
}
.home-foot-catalog-label {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 14px;
  background: #ffa025;
  color: #1a1a1a;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
}
.home-foot-catalog-sep {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.35);
  font-size: 28px;
  font-weight: 700;
  margin: 0 4px;
}
.home-foot-catalog-chip {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
  white-space: nowrap;
}
.home-foot-catalog-chip-play {
  background: rgba(0, 153, 238, 0.28);
  border: 1px solid rgba(0, 153, 238, 0.55);
}
.home-foot-catalog-chip-tool {
  background: rgba(255, 160, 37, 0.18);
  border: 1px solid rgba(255, 160, 37, 0.5);
}
.home-foot-time {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 11;
  border-radius: 50px 0px 0px 0px;
  background: #000000;
  padding: 25px 236px 30px 30px;
  height: 136px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  pointer-events: none;
}
.home-foot-date {
  display: flex;
  align-items: flex-end;
}
.home-foot-year {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
}
.home-foot-md {
  margin-left: 10px;
  font-size: 50px;
  font-weight: bold;

  /* 纯白 */
  color: #ffffff;
}
.home-foot-time-info {
  display: flex;
  align-items: center;
}
.home-foot-week {
  font-size: 25px;
  font-weight: bold;
  color: #ffffff;
}
.home-foot-time-ms {
  margin-left: 13px;
  font-size: 31.5px;
  font-weight: bold;
  color: #ffffff;
}

.barrage-box {
  /* width: 470px; */
  /* height: 114px; */
  /* border-radius: 60px; */
  display: flex;
  align-items: center;
  position: relative;
  /* justify-content: center; */
  /* padding: 20px 30px 20px 20px; */
  /* background: #FFFFFF; */
}

.barrage-box-up-img-box {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
}
.barrage-box-down-img-box {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
}

.barrage-info-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* overflow: hidden; */
  position: relative;
}

.barrage-info-box-minnow {
  overflow: hidden;
  border-radius: 10px;
}

.barrage-info-up {
  padding: 0 20px;
  font-size: 28px;
  height: 44px;
  line-height: 44px;
}
.barrage-info-down {
  padding: 0 20px;
  font-size: 28px;
  height: 36px;
  line-height: 36px;
}
</style>
